module.exports = __webpack_public_path__ + "static/media/promotional_9.3f666761.png";